import { Controller } from "@hotwired/stimulus"

// Auto-submits a GET filter form when one of its <select>s changes.
// choices.js dispatches a native `change` on the underlying select it
// wraps, so this works for choices-enhanced selects too. Scoped to SELECT
// so the free-text search field keeps its normal submit-on-Enter behavior
// instead of firing on every blur.
export default class extends Controller {
  submit(event) {
    if (event.target.tagName === "SELECT") {
      this.element.requestSubmit()
    }
  }
}
